import { Box, Breadcrumbs, Grid, Typography } from '@mui/material';
import {
  Edit,
  Form,
  Labeled,
  SaveButton,
  TextInput,
  required,
} from 'react-admin';
import { Link, useParams } from 'react-router-dom';
import { CheckboxMultipleSelector } from '../../components/CheckboxMultipleSelector';
import { CustomTransferList } from '../../components/CustomTransferList';

export const TeamEdit = () => {
  const { id } = useParams();
  return (
    <Box pt={2}>
      <Breadcrumbs aria-label="breadcrumb">
        <Typography
          color="inherit"
          sx={{ fontSize: '14px', fontWeight: '400', lineHeight: '19px' }}
          component={Link}
          to="/teams"
        >
          Equipo
        </Typography>
        <Typography
          color="textPrimary"
          sx={{ fontSize: '14px', fontWeight: '600', lineHeight: '19px' }}
        >
          Editar equipo
        </Typography>
      </Breadcrumbs>
      <Box maxWidth={{ xs: '100%', sm: 850 }} mt={{ xs: 2 }} mx="auto">
        <Typography color="textPrimary" variant="h5">
          Editar equipo
        </Typography>
        <Edit
          resource="teams"
          id={id}
          title={' '}
          sx={{ '& .RaEdit-card': { p: 2 } }}
        >
          <Form>
            <Box>
              <TextInput source="name" label="Nombre" validate={[required()]} />
              <CheckboxMultipleSelector
                name="leaders"
                reference="members"
                source="id"
                label="Lider/s"
                preloadedValue={true}
              />
            </Box>
            <Labeled label="Selecionar integrantes del equipo" my={{ xs: 4 }}>
              <CustomTransferList name="members" source="id" label="Miembros" />
            </Labeled>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              <SaveButton
                sx={{
                  backgroundColor: '#3F49DB',
                  borderRadius: '500px !important',
                  textTransform: 'none !important',
                  fontSize: '14px !important',
                  lineHeight: '19px !important',
                  fontWeight: '600 !important',
                  letterSpacing: '0.5px !important',
                  padding: '8px 32px!important',
                  boxShadow: 'none !important',
                  svg: {
                    display: 'none',
                  },
                }}
              />
            </Grid>
          </Form>
        </Edit>
      </Box>
    </Box>
  );
};
